/* global dataLayer */

import { isNil } from "ramda";
import { browserName, deviceType, osName } from "react-device-detect";

import UserPresenter from "presenters/UserPresenter";
import OfferPresenter from "presenters/OfferPresenter";
import TemplatePresenter from "presenters/TemplatePresenter";

const sendUserData = (user) => {
  const userData = {
    user: {
      id: UserPresenter.id(user),
      email: UserPresenter.email(user),
      name: UserPresenter.firstName(user),
      "logged-in": UserPresenter.isRegistered(user) ? "yes" : "no",
      member: UserPresenter.isPaid(user) ? "yes" : "no",
      browser: browserName,
      os: osName,
      device: deviceType === "browser" ? "desktop" : deviceType,
    },
  };

  dataLayer.push(userData);
};

export const sendRegistrationSuccessEvent = (user) => {
  sendUserData(user);
  dataLayer.push({
    event: "registrationSuccess",
  });
};

export const sendPaymentSuccessEvent = (user, type, offer, subscriptionId, template) => {
  const dataObj = {
    event: "paymentSuccess",
    "offer-name": OfferPresenter.name(offer),
    "offer-duration": `${OfferPresenter.duration(offer)} ${OfferPresenter.durationUnit(offer)}`,
    revenue: OfferPresenter.price(offer),
    "payment-method": type,
    "subscription-slug": subscriptionId,
    "in-flow": "no",
  };

  if (typeof template !== "undefined") {
    dataObj["in-flow"] = "yes";
    dataObj["template-id"] = TemplatePresenter.id(template);
    dataObj["template-short-name"] = TemplatePresenter.name(template);
    dataObj.product = {
      "template-group-slug": TemplatePresenter.templateGroupSlug(template),
      "template-slug": TemplatePresenter.id(template),
      "template-cast-size": TemplatePresenter.castNum(template),
    };
  }

  dataLayer.push(dataObj);
  sendUserData(user);
};

export const sendActivateEvent = () => dataLayer.push({ event: "optimize.activate" });

export const sendTrackVirtualPageView = (user, payload) => {
  const gtmData = isNil(payload) ? {} : payload;

  const pageInfo = {
    title: document.title,
    url: window.location.href,
  };

  if ("in-flow" in gtmData) {
    gtmData["in-flow"] = gtmData["in-flow"] ? "yes" : "no";
  }

  const dataObj = {
    event: "virtualPageView",
    page: { ...pageInfo, ...gtmData },
  };

  dataLayer.push(dataObj);
  sendUserData(user);
};
